import { SVGProps } from "react"

const MarkerIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="33"
      height="43"
      viewBox="0 0 33 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.502 27.2643C25.4564 31.5813 16.2981 42.3758 16.2981 42.3758C16.2981 42.3758 7.13977 31.5813 4.09416 27.2643C-1.90423 18.7621 -1.09171 10.3838 5.09558 4.45029C8.18896 1.48326 12.2435 0 16.2981 0C20.3526 0 24.4072 1.48326 27.5006 4.45029C33.6879 10.3838 34.4999 18.7621 28.502 27.2643Z"
        fill={props.fill || "#2768A3"}
      />
    </svg>
  )
}

export default MarkerIcon
